module.exports = __webpack_public_path__ + "img/roche-logo.f65e728a.svg";